.copyIconContainer {
    cursor: pointer;
}
  
.copyIconContainer:hover {
    filter: hue-rotate(240deg) saturate(100%) brightness(1.5);  /* Add the grayscale filter on hover */
}
